import {createContext} from "react"
import {ContentCard, ContentCardBanner, ContentCardTrigger, ContentCardMessage, LegacyNotificationCard} from "./ContentCard"

export const initial: Context = {
  notifications: [],
  notificationsCount: 0,
  banners: [],
  triggers: [],
  messages: []
}
export type Context = {
  notifications: LegacyNotificationCard[]
  notificationsCount: number
  banners: ContentCardBanner[]
  contentCardPopup?: ContentCard
  triggers: ContentCardTrigger[]
  messages: ContentCardMessage[]
}

export type ActionsContext = {
  showPopup(contentCard: ContentCard): void
  clearPopup(): void
  refresh(): void
  /**
   * Mark any cards as 'actioned', i.e if they were to be hidden when viewed,
   * calling this should then actually remove them from view
   *
   * This is not to be confused with a refresh which syncs the client with the
   * braze servers, this merely syncs the local state of what has been viewed
   * with the UI. e.g if banner should be dismissed once it's nested popup is
   * clicked, we don't want to remove tha banner until the popup is 'actioned'
   */
  markCardsAsActioned(ids: string[]): void
  markContentCardClicked(
    id: string,
    opts?: {
      /** immidiately mark this as actioned, effectively removing the card if `hideIf='clicked'` */
      actioned: boolean
    }
  ): void
  markContentCardsImpression(ids: string[]): void
  markContentCardsDismissed(ids: string[]): void
}

export const NotificationContext = createContext<Context>(initial)
export const NotificationActionContext = createContext<ActionsContext | null>(null)
